import React from 'react'
import { FiChevronRight, FiChevronDown } from 'react-icons/fi'
import { experiments, jobList } from './mock'
import { getTime } from '../../../@shared/utils'

export const Feature = () => { 
    const [show,setShow] = React.useState(true)

    const handleShow = (e) => {
        e.preventDefault();
        experiments?.length > 0 && setShow(!show);
    }

    let item = {
        title:'Education',
        description:'Enter your education information'
    }

    const [limit,setLimit] = React.useState(2)
     return (
    <div className="feature2">
            <div className="heading" onClick={(e)=>handleShow(e)}>  
                <div>
                    <h4>{item?.title}</h4>
                    <p>{item?.description}</p>
                </div>
                <div className="setting">
                    {!show ? <FiChevronRight /> : <FiChevronDown /> }
                </div>
                
            </div>
            { show && jobList?.length > 0 && <React.Fragment>
                <ul>
                { jobList?.map((item,i)=>
                 limit > i ?
                 (
                    <li>
                        <h4 className="title">{item?.position}</h4>
                        <h5 className="name">{item?.company}</h5>
                        {item.start && <p className="date"> {item?.start && getTime(item?.start)} {` / `} {item?.end ? getTime(item?.end) : 'Current'} </p>}
                        <p className="description">{ item?.description.substr(1,250) }</p>
                    </li>
                    ) : <></> )}
                </ul>
                { jobList?.length>limit  && <div className="button" onClick={()=>{setLimit(jobList.length)}}><p>Load more</p></div>  }  
            </React.Fragment>}
        </div>
    ) 

}
